/* Qua policy pages. Built from design/website-trial/privacy.html by build-policy.js: edit the preview, not this file. */
/* ---------- The policy page: reads the policy exactly as saved in Shopify (plain lines) and lays it out ---------- */
(() => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const docEl = document.documentElement;

  /* Theme: follows the system; the toggle overrides and is remembered (shared with the homepage) */
  const themeBtn = $("#themeBtn"), themeMeta = document.querySelector('meta[name="theme-color"]'), sysLight = matchMedia("(prefers-color-scheme: light)");
  const eff = () => docEl.dataset.theme || (sysLight.matches ? "light" : "dark");
  function applyTheme() {
    const e = eff();
    themeBtn.setAttribute("aria-label", e === "light" ? "Switch to dark mode" : "Switch to light mode");
    if (themeMeta) themeMeta.content = e === "light" ? "#F5F5F7" : "#0A0A0A";
  }
  themeBtn.addEventListener("click", () => {
    docEl.dataset.theme = eff() === "light" ? "dark" : "light";
    try { localStorage.setItem("qua-theme", docEl.dataset.theme); } catch (e) {}
    applyTheme();
  });
  sysLight.addEventListener("change", applyTheme);
  applyTheme();

  const source = $(".shopify-policy__body .rte") || $(".shopify-policy__body");
  const contactPage = !!$("[data-qua-contact]"); // the Contact page: same frame, no policy text, just the contact box
  if (!source && !contactPage) return;
  const text = el => el.textContent.replace(/\s+/g, " ").trim();
  const TITLES = contactPage ? { en: "Contact us", nl: "Neem contact op" } : { en: "Privacy policy", nl: "Privacybeleid" };
  const ownTitle = text($(".shopify-policy__title") || $("#pTitle")); // other policies (e.g. Contact information) keep their own title
  const DATE = /^(Last updated|Laatst bijgewerkt):?\s*/i;

  /* Split the saved text into English and Dutch at the line of dashes */
  const parts = { en: [], nl: [] }, dates = { en: "", nl: "" };
  let cur = "en";
  if (source) [...source.children].forEach(el => {
    const t = text(el);
    if (/^[—–-]{3,}$/.test(t)) { cur = "nl"; return; }
    if (!t || /^Privacybeleid \(Nederlands\)$/i.test(t)) return;
    if (/^\S+(\s\S+){0,2}:$/.test(t)) return; // a label Shopify prints with nothing filled in (e.g. "VAT number:")
    if (DATE.test(t) && !dates[cur]) { dates[cur] = t; return; }
    parts[cur].push(el);
  });

  /* A short line with no closing punctuation is a section title; "When you…" / "Als je…" lines are sub-titles */
  const isTitle = t => t.length <= 60 && !/^•/.test(t) && !/@/.test(t) && !/[.:;!?)]$/.test(t);
  const isSub = t => /^(When you|Als je)\b/i.test(t);
  const linkEmail = html => html.replace(/info@quabottle\.com/g, '<a href="mailto:info@quabottle.com">info@quabottle.com</a>');

  function build(lang) {
    const wrap = document.createElement("div");
    wrap.className = "lang-body"; wrap.lang = lang; wrap.hidden = true;
    let section = null, n = 0;
    const open = () => { section = document.createElement("section"); wrap.appendChild(section); };
    parts[lang].forEach(el => {
      const t = text(el);
      if (isTitle(t) && !isSub(t)) {
        open(); const h = document.createElement("h2"); h.textContent = t;
        section.id = lang + "-" + (++n); section.appendChild(h); return;
      }
      if (!section) open();
      if (isTitle(t)) { const h = document.createElement("h3"); h.textContent = t; section.appendChild(h); return; }
      if (/^•/.test(t)) {
        const ul = document.createElement("ul");
        el.innerHTML.split(/<br\s*\/?>/i).map(s => s.replace(/^\s*•\s*/, "").trim()).filter(Boolean).forEach(s => {
          const li = document.createElement("li");
          // the words before the first full stop or colon carry the point: set them a touch stronger
          li.innerHTML = linkEmail(s.replace(/^([^.:]{2,70}?)([.:])(\s)/, "<b>$1</b>$2$3"));
          ul.appendChild(li);
        });
        section.appendChild(ul); return;
      }
      const p = document.createElement("p");
      p.innerHTML = linkEmail(el.innerHTML.replace(/<br\s*\/?>\s*$/i, ""));
      if (/^Qua\s·\s*info@/.test(t)) p.className = "contact";
      section.appendChild(p);
    });
    return wrap;
  }

  /* The contact box at the end of "Contact". On Shopify it is a real Shopify contact form (sent to info@quabottle.com) */
  const WRITE = {
    en: { title: "Write to us", lede: "Questions about your data, the waitlist or Qua. We reply by email.", name: "Name", email: "Email", message: "Message",
      pName: "Your name", pEmail: "Your email", pMessage: "Your message", note: "We use your name and email only to reply to you.", send: "Send message",
      eName: "Enter your name.", eEmail: "Enter a valid email address, like name@example.com.", eMessage: "Write a message first.", sending: "Sending…",
      fail: "That didn't go through. Please try again in a moment.", thanks: n => "Thanks, " + n + ".", reply: e => "We'll reply to " + e + "." },
    nl: { title: "Schrijf ons", lede: "Vragen over je gegevens, de wachtlijst of Qua. We antwoorden per e-mail.", name: "Naam", email: "E-mail", message: "Bericht",
      pName: "Je naam", pEmail: "Je e-mailadres", pMessage: "Je bericht", note: "We gebruiken je naam en e-mailadres alleen om je te antwoorden.", send: "Verstuur bericht",
      eName: "Vul je naam in.", eEmail: "Vul een geldig e-mailadres in, zoals naam@voorbeeld.nl.", eMessage: "Schrijf eerst een bericht.", sending: "Versturen…",
      fail: "Dat lukte niet. Probeer het zo nog eens.", thanks: n => "Bedankt, " + n + ".", reply: e => "We antwoorden naar " + e + "." }
  };
  /* the Contact page's fuller form: first and last name, email, an optional phone number */
  const FULL = {
    en: { first: "First name", last: "Last name", phone: "Phone (optional)", ePhone: "Check the phone number, or leave it empty.", eFirst: "Enter your first name." },
    nl: { first: "Voornaam", last: "Achternaam", phone: "Telefoon (optioneel)", ePhone: "Controleer het telefoonnummer, of laat het leeg.", eFirst: "Vul je voornaam in." }
  };
  function writeBox(lang, full) {
    const w = WRITE[lang], fw = FULL[lang], id = s => lang + "-" + s;
    const box = document.createElement("div");
    box.className = "write" + (full ? " write-full" : "");
    const nameRows = full ? `
        <input type="hidden" name="contact[name]">
        <div class="row">
          <label class="sr-only" for="${id("first")}">${fw.first}</label><input id="${id("first")}" name="contact[First name]" type="text" autocomplete="given-name" placeholder="${fw.first}" maxlength="60" required>
          <label class="sr-only" for="${id("last")}">${fw.last}</label><input id="${id("last")}" name="contact[Last name]" type="text" autocomplete="family-name" placeholder="${fw.last}" maxlength="60">
        </div>
        <div class="row">
          <label class="sr-only" for="${id("email")}">${w.email}</label><input id="${id("email")}" name="contact[email]" type="email" autocomplete="email" inputmode="email" placeholder="${w.pEmail}" required>
          <label class="sr-only" for="${id("phone")}">${fw.phone}</label><input id="${id("phone")}" name="contact[phone]" type="tel" autocomplete="tel" inputmode="tel" placeholder="${fw.phone}" maxlength="30">
        </div>` : `
        <div class="row">
          <label class="sr-only" for="${id("name")}">${w.name}</label><input id="${id("name")}" name="contact[name]" type="text" autocomplete="name" placeholder="${w.pName}" maxlength="80" required>
          <label class="sr-only" for="${id("email")}">${w.email}</label><input id="${id("email")}" name="contact[email]" type="email" autocomplete="email" inputmode="email" placeholder="${w.pEmail}" required>
        </div>`;
    // on the Contact page the page title already says it, so the box goes without its own title
    box.innerHTML = (full ? "" : `<h3>${w.title}</h3><p class="lede">${w.lede}</p>`) + `
      <form class="contact-form" method="post" action="/contact#contact_form" accept-charset="UTF-8" novalidate>
        <input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="contact[language]" value="${lang}">${nameRows}
        <label class="sr-only" for="${id("message")}">${w.message}</label><textarea id="${id("message")}" name="contact[body]" placeholder="${w.pMessage}" maxlength="3000" required></textarea>
        <div class="send"><p class="note">${w.note}</p><button class="btn" type="submit">${w.send}</button></div>
        <p class="msg" role="status" aria-live="polite"></p>
      </form>`;
    const form = box.querySelector("form"), msg = box.querySelector(".msg"), btn = box.querySelector("button");
    const done = (ok, name, email) => {
      if (!ok) { msg.textContent = w.fail; btn.disabled = false; return; }
      const d = document.createElement("div"); d.className = "done"; d.setAttribute("role", "status");
      d.innerHTML = `<b></b><span></span>${window.quaSendContact ? "" : '<span class="note">Preview: no message was sent.</span>'}`;
      d.querySelector("b").textContent = w.thanks(name.split(/\s+/)[0]); d.querySelector("span").textContent = w.reply(email);
      form.replaceWith(d);
    };
    form.addEventListener("submit", e => {
      const f = form.elements, email = f["contact[email]"].value.trim(), body = f["contact[body]"].value.trim();
      const stop = (t, el) => { e.preventDefault(); e.stopImmediatePropagation(); msg.textContent = t; el.focus(); };
      let name;
      if (full) {
        const first = f["contact[First name]"].value.trim(), phone = f["contact[phone]"].value.trim();
        if (!first) return stop(fw.eFirst, f["contact[First name]"]);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return stop(w.eEmail, f["contact[email]"]);
        if (phone && !/^\+?[\d\s().-]{6,}$/.test(phone)) return stop(fw.ePhone, f["contact[phone]"]);
        name = (first + " " + f["contact[Last name]"].value.trim()).trim();
        f["contact[name]"].value = name; // the full name, as Shopify's email shows it
      } else {
        name = f["contact[name]"].value.trim();
        if (!name) return stop(w.eName, f["contact[name]"]);
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return stop(w.eEmail, f["contact[email]"]);
      if (!body) return stop(w.eMessage, f["contact[body]"]);
      msg.textContent = w.sending; btn.disabled = true;
      // on Shopify the site script sends it through Shopify's spam check, in the background; the preview only shows the result
      if (window.quaSendContact) return window.quaSendContact(form, e, ok => done(ok, name, email));
      e.preventDefault(); setTimeout(() => done(true, name, email), 500);
    });
    return box;
  }

  const CONTACT = {
    en: { lede: "Questions about Qua, the bottle or the waitlist? Send us a message and we'll reply by email.", mail: "Prefer email?", follow: "Follow along" },
    nl: { lede: "Vragen over Qua, de fles of de wachtlijst? Stuur ons een bericht, dan antwoorden we per e-mail.", mail: "Liever mailen?", follow: "Volg ons" }
  };
  const ICON = {
    instagram: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="17.3" cy="6.7" r="1.2" fill="currentColor"/></svg>',
    linkedin: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="4" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 10.5V16M8 7.6v.1M11.5 16v-5.5M11.5 13c0-1.6 1-2.6 2.4-2.6s2.1 1 2.1 2.6V16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 3.5v11.2a3.3 3.3 0 1 1-3.3-3.3M14.5 3.5c.4 2.7 2.3 4.4 5 4.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  function contactBody(lang) {
    const c = CONTACT[lang], wrap = document.createElement("div");
    wrap.className = "lang-body contact-body"; wrap.lang = lang; wrap.hidden = true;
    const side = document.createElement("div"); side.className = "contact-side";
    side.innerHTML = `<p class="contact-lede">${c.lede}</p>
      <div class="contact-way"><span>${c.mail}</span>${linkEmail("info@quabottle.com")}</div>
      <div class="contact-way"><span>${c.follow}</span><div class="socials">
        <a href="https://www.instagram.com/qua_bottle" target="_blank" rel="noopener">${ICON.instagram}Instagram</a>
        <a href="https://www.linkedin.com/company/qua-bottle/" target="_blank" rel="noopener">${ICON.linkedin}LinkedIn</a>
        <a href="https://www.tiktok.com/@quabottle" target="_blank" rel="noopener">${ICON.tiktok}TikTok</a>
      </div></div>`;
    const sun = document.createElement("div"); sun.className = "sun"; sun.setAttribute("aria-hidden", "true");
    wrap.append(sun, side, writeBox(lang, true));
    return wrap;
  }

  let bodies;
  if (contactPage) {
    bodies = { en: contactBody("en"), nl: contactBody("nl") };
    $(".policy-page").classList.add("contact-mode");
  } else {
    bodies = { en: build("en") };
    if (parts.nl.length) bodies.nl = build("nl");
    // the box goes at the end of the last section ("Contact" / "Contact")
    Object.entries(bodies).forEach(([lang, b]) => { const last = b.querySelector("section:last-of-type"); if (last) last.appendChild(writeBox(lang)); });
    (source.closest(".shopify-policy__container") || source.parentElement).hidden = true;
  }
  Object.values(bodies).forEach(b => $("#policy").appendChild(b));

  /* The short index on the left follows the language and the reading position */
  const toc = $("#toc");
  let spy;
  function buildToc(lang) {
    toc.innerHTML = "<span>" + (lang === "nl" ? "Op deze pagina" : "On this page") + "</span>";
    const links = $$(`.lang-body[lang="${lang}"] section[id]`).map(s => {
      const a = document.createElement("a"); a.href = "#" + s.id; a.textContent = s.querySelector("h2").textContent;
      a.addEventListener("click", e => { e.preventDefault(); s.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }); });
      toc.appendChild(a); return a;
    });
    if (spy) spy.disconnect();
    spy = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) links.forEach(a => a.classList.toggle("on", a.getAttribute("href") === "#" + e.target.id));
    }), { rootMargin: "-20% 0px -70% 0px" });
    $$(`.lang-body[lang="${lang}"] section[id]`).forEach(s => spy.observe(s));
  }

  const seg = $("#lang"), btns = $$("#lang button");
  function setLang(lang, remember) {
    if (!bodies[lang]) lang = "en";
    Object.entries(bodies).forEach(([k, b]) => b.hidden = k !== lang);
    btns.forEach(b => b.setAttribute("aria-checked", b.dataset.lang === lang));
    $("#pTitle").textContent = bodies.nl ? TITLES[lang] : ownTitle;
    $("#pDate").textContent = dates[lang]; $("#pDate").hidden = !dates[lang];
    docEl.lang = lang;
    buildToc(lang);
    if (remember) try { localStorage.setItem("qua-lang", lang); } catch (e) {}
  }
  btns.forEach(b => b.addEventListener("click", () => setLang(b.dataset.lang, true)));
  seg.hidden = !bodies.nl;

  let start = "en";
  try { start = localStorage.getItem("qua-lang") || ""; } catch (e) {}
  if (location.hash === "#nederlands") start = "nl";
  if (!start) start = /^nl\b/i.test(navigator.language || "") ? "nl" : "en";
  setLang(start, false);
})();

/* ---------- On Shopify: the contact box is a real Shopify contact form (to info@quabottle.com), protected by
   Shopify's invisible spam check. When the check passes, Shopify adds its token and calls the form's own submit(),
   which here sends in the background, so the page never reloads. ---------- */
(() => {
  const forms = [...document.querySelectorAll(".contact-form")];
  const isBound = f => f.hasAttribute("data-hcaptcha-bound");
  const waitForBinding = f => new Promise(res => { const t0 = Date.now(); (function check() { if (isBound(f)) return res(true); if (Date.now() - t0 > 4000) return res(false); setTimeout(check, 100); })(); });
  const protect = f => { try { window.Shopify && Shopify.captcha && Shopify.captcha.protect(f); } catch (e) {} };
  const answer = new WeakMap();
  forms.forEach(f => {
    f.submit = () => fetch(f.action, { method: "POST", body: new FormData(f), credentials: "same-origin" }).then(r => {
      const done = answer.get(f) || (() => {});
      if (r.url.includes("contact_posted=true")) return done(true);
      // Shopify wants a visible check: go to Shopify's own check page; it sends the message on and brings the visitor
      // back with ?contact_posted=true, where the thanks shows (a token-less resend earned "Missing CAPTCHA token")
      if (r.url.includes("/challenge")) return location.assign(r.url);
      done(false);
    }).catch(() => (answer.get(f) || (() => {}))(false));
    protect(f);
  });
  window.quaSendContact = (f, e, done) => {
    answer.set(f, done);
    if (!isBound(f)) protect(f);
    if (isBound(f)) return; // Shopify's check takes it from here, then calls f.submit()
    e.preventDefault();
    waitForBinding(f).then(b => b ? f.requestSubmit() : f.submit());
  };
  // back from Shopify's visible check: thank them in the contact box
  if (/[?&]contact_posted=true/.test(location.search)) {
    forms.forEach(f => {
      const nl = f.closest('[lang="nl"]'), d = document.createElement("div");
      d.className = "done"; d.setAttribute("role", "status");
      d.innerHTML = nl ? "<b>Bedankt.</b><span>We antwoorden per e-mail.</span>" : "<b>Thanks.</b><span>We'll reply by email.</span>";
      f.replaceWith(d);
    });
    history.replaceState(null, "", location.pathname);
    const box = document.querySelector('.lang-body:not([hidden]) .write'); if (box) box.scrollIntoView();
  }
})();